import feedbackExpressions from './feedback-expressions';

export default {
  expressions: {
    ...feedbackExpressions,
    PRIMARY: 'Primary',
    SECONDARY: 'Secondary',
    CONTROL: 'Control',
    DISABLED: 'Disabled',
    ON_CONTRAST: 'OnContrast',
    CHOSEN: 'Chosen',
    COMPLETED: 'Completed'
  },
  properties: {
    BACKGROUND_COLOR: 'backgroundColor',
    FOREGROUND_COLOR: 'foregroundColor',
    BORDER_COLOR: 'borderColor',
    OUTLINE_COLOR: 'outlineColor',
    SHADOW_COLOR: 'shadowColor',
    FEEDBACK_COLOR: 'feedbackColor',
    ON_FEEDBACK_COLOR: 'onFeedbackColor',
    FIGURE_COLOR: 'figureColor',
    BORDER_RADIUS: 'borderRadius',
    BORDER_WIDTH: 'borderWidth',
    FONT_FAMILY: 'fontFamily',
    FONT_SIZE: 'fontSize',
    FONT_WEIGHT: 'fontWeight',
    LINE_HEIGHT: 'lineHeight',
    TEXT_DECORATION: 'textDecoration',
    DENSITY: 'density'
  },
  interactions: {
    FOCUSED: 'Focused',
    GRABBED: 'Grabbed',
    HOVERED: 'Hovered',
    PRESSED: 'Pressed',
    CHOSEN: 'Chosen'
  },
  features: {
    BODY: 'body',
    CONTENT: 'content',
    DESCRIPTION: 'description',
    LABEL: 'label',
    METER: 'meter',
    KNOB: 'knob',
    INDICATOR: 'indicator',
    TITLE: 'title',
    ITEM: 'item',
    BACKDROP: 'backdrop'
  }
};
